<div class="preauth-container">
    <tm1-typography type = "title-page">Login</tm1-typography>
    <br/>
    <ng-container *ngIf="errorMessage !== ''">
        <tm1-banner variant = "error">{{errorMessage}}</tm1-banner>
        <br/>
    </ng-container>
    <tm1-card variant = "shadow" class = "card-container">
      <input (keydown.enter) = "onLogin()" class="form-control" type="email" placeholder="Email" [(ngModel)]="email" name="email" required />
      <input (keydown.enter) = "onLogin()" class ="form-control" type="password" placeholder="Password" [(ngModel)]="password" name="password" required />
      <tm1-button (click)="onLogin()">Login</tm1-button>
    <tm1-typography type = "body"><a routerLink="/passwordreset">Forgot Password</a></tm1-typography>
    </tm1-card>
  </div>